import { cn } from "@/utils/cn";

import styles from "./Badge.module.scss";

enum BadgeVariant {
  Default = "default",
  Primary = "primary",
  Secondary = "secondary",
  Success = "success",
  Inverse = "inverse",
  Info = "info",
  Warning = "warning",
  Danger = "danger",
}

enum BadgeSize {
  Small = "small",
  Medium = "meduim",
  Large = "large",
}

enum BadgeShape {
  Square = "square",
  Rounded = "rounded",
  Pill = "pill",
}

enum BadgeAppearance {
  Filled = "filled",
  Outlined = "outlined",
  Silent = "silent",
}

type BadgeProps = {
  className?: string;
  variant?: BadgeVariant;
  size?: BadgeSize;
  shape?: BadgeShape;
  appearance?: BadgeAppearance;
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

const Badge: React.FC<BadgeProps> = ({
  children,
  className,
  variant = BadgeVariant.Secondary,
  size = BadgeSize.Medium,
  shape = BadgeShape.Pill,
  appearance = BadgeAppearance.Filled,
  style,
  ...rest
}) => {
  return (
    <div
      role="status"
      style={style}
      className={cn(
        styles.container,
        styles[variant],
        styles[size],
        styles[shape],
        styles[appearance],
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export { Badge, BadgeVariant, BadgeSize, BadgeShape, BadgeAppearance };
export type { BadgeProps };
